/* eslint-disable */ // слишком много всего править по линтеру, у кого есть желание - welcome
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import "moment/dist/locale/ru";

import { inject, observer } from "mobx-react";
// import { computed, toJS } from "mobx";

// import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
// import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
// import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { confirmPopup } from "primereact/confirmpopup";
import { FileUpload } from "primereact/fileupload";
import { addLocale, locale } from "primereact/api";

import { Message } from "primereact/message";

// import TimeArray from "./NodeComponents/TimeArray";
import Image from "./NodeComponents/Image";
// import Sound from "./NodeComponents/Sound";
// import Pdf from "./NodeComponents/Pdf";
// import Document from "./NodeComponents/Document";
// import CodeEditor from "./NodeComponents/CodeEditor";
import "./style.scss";
// import { SelectButton } from "primereact/selectbutton";
import { Accordion, AccordionTab } from "primereact/accordion";
import PreviewDisclaimer from "./NodeComponents/PreviewDisclaimer";
// import ExtendedOfferLogic from "../Promo/Offers/ExtendedOfferLogic";
import moment from "moment";
import { getValByPath, translit } from "../../../helpers/utils";
import { InputSwitch } from "primereact/inputswitch";
import { Slider } from "primereact/slider";
import ReorderList from "./NodeComponents/ReorderList";
import HtmlText from "./NodeComponents/HtmlText";
import Preview from "./NodeComponents/Preview";
import DefaultCard from "./NodeComponents/DefaultCard";
import Rates from "./NodeComponents/Rates";
import Questions from "./NodeComponents/Questions";
import InputUI from "@UI/InputUI";
import CheckboxUI from "@UI/CheckboxUI";
import SelectButtonUI from "@UI/SelectButtonUI";
import RadioButtonUI from "@UI/RadioButtonUI";
import InputNumberUI from "@UI/InputNumberUI";
// import MultiSelectSuggestUI from "@UI/InputNumberUI";
import CopyTagUI from "@UI/CopyTagUI";
import ButtonUI from "@UI/ButtonUI";
import Ord from "./NodeComponents/ORD";
import CompaniesOrd from "./NodeComponents/CompaniesORD";
import CompaniesGeo from "./NodeComponents/CompaniesGeo";
import RatesTraffic from "./NodeComponents/RatesTraffic";
import BucketDetail from "./NodeComponents/BucketDetail";
import BucketsUpload from "./NodeComponents/BucketsUpload";
import DeviceTarget from "./NodeComponents/DeviceTarget";

import OfferSortConfig from "./NodeComponents/OfferSortConfig";
import InputTextareaUI from "@UI/InputTextareaUI";
import WeekDaysSlider from "./NodeComponents/WeekDaysSlider";

addLocale("rus", {
    firstDayOfWeek: 1,
    dayNames: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Субота"],
    dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", " ноябрь", "декабрь"],
    monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    today: "Сегодня",
    clear: "Очистить",
});

locale("rus");
moment.locale("ru");

const CreateNode = inject("mainStore")(
    observer(
        forwardRef(
            (
                {
                    mainStore,
                    fullData, //Это полный объекь с данными
                    keyTo, //уникальный ключ используется для валидации
                    item, //объект с инфой по полю
                    value, //текущий value
                    setData, //иземенение переменной
                    setDataMulti, //иземенение переменной
                    prePath = [], //если много вложенностей то тут путь до это вложенности
                    isAdd = false, //если много вложенностей то тут путь до это вложенности
                    dataId = [], //путь до input для ошибок
                    disabled = false, //возможность редактировать
                    minDate = null, //минимальная дата для date полей
                    maxDate = null, //максимальная дата для date полей
                    hide = false, //показать скрыть
                    siteId = false, //показать скрыть
                    urlUpload = false, // для загрузки картинок
                    multiple = true,
                    changeableData = [],
                    inputFieldsDisable,
                    isScroll = false,
                    getButtons = () => {},
                    errorArr = [],
                    getDetailData = () => {}
                },
                ref,
            ) => {
                const dataOptions = item.dataKey ? mainStore.getMainStore(item.dataKey) : undefined;

                const [isRefrashed, setIsRefrashed] = useState(false);
                const [isRender, setIsRender] = useState(false);

                let defOptionsSuggest = item && item.options ? item.options : dataOptions ? dataOptions : [];
                let optionsSuggest = defOptionsSuggest.map((i) => ({ ...i, title: i.title?.replace(/<\/?[^>]+(>|$)/g, "").replace(/\u00A0|&nbsp;/g, " ") }));
                const fileInputRef = useRef(null);
                let validEmail = item.type === "email" ? useRef(null) : null;
                const key = keyTo;

                useEffect(() => {
                    if (item.defValue && isAdd) {
                        handleValueChange(null, null, item.defValue);
                    }

                    if (typeof item.defaultValue !== "undefined" && !isAdd && item.defaultValue !== null && item.handleDefaultFun) {
                        item.handleDefaultFun(); // функция для выставления дефолтного значения
                    }
                    if (item.type === "selectButton" && item.options) {
                        setDataMulti([keyTo], item.options[0].value);
                    }
                }, []);

                useEffect(() => {
                    if (item.refetchOnMountData && !isRefrashed) {
                        getData();
                        setIsRefrashed(true);
                    }

                    setIsRender(true);
                }, [item]);

                useImperativeHandle(ref, () => {
                    return {
                        clear() {
                            fileInputRef?.current?.clear();
                        },
                    };
                }, []);

                const getData = async () => {
                    let api = item.apiUrl;
                    if (item.addAdditionalApi) {
                        api = item.apiUrl + item.addAdditionalApi(changeableData);
                    }
                    const resp = await mainStore.getByUrl(api);
                    if (resp && resp.success) {
                        mainStore.setMainStore(item.dataKey, resp.data);
                    }
                };

                const handleCopy = () => {
                    const selected = optionsSuggest.find((f) => f._id == value);
                    navigator.clipboard.writeText(selected?.title);
                };

                const handleInputChange = (e, id) => {
                    let errText = document.querySelector(`small[id="${id}"]`);
                    if (errText) {
                        errText.innerHTML = "";
                    }

                    if (item.type === "email") {
                        let match = e.target.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                        validEmail.current = !match;
                    } else {
                        if (e.originalEvent) {
                            e.originalEvent?.target?.classList?.remove("p-invalid");
                        } else {
                            e.target?.classList?.remove("p-invalid");
                        }
                    }

                    let itemToChange = [];
                    let valueNext = e.target.value;
                    if (valueNext === undefined) {
                        if (e.target.id.includes("Id")) {
                            valueNext = null;
                        }
                    }

                    const clickSelectAll = e?.originalEvent?.originalEvent?.target?.closest(".p-multiselect-select-all");
                    if (item.showSelectAll && clickSelectAll) {
                        valueNext = [...new Set([...value, ...valueNext])];
                    }

                    itemToChange.push({ path: prePath.concat(key), value: valueNext });
                    if (item.translitTo) {
                        itemToChange.push({ path: prePath.concat(item.translitTo), value: translit(valueNext) });
                    }
                    if (item.duplicateToPath && item.duplicateToPath.length) {
                        itemToChange.push({ path: item.duplicateToPath, value: valueNext });
                    }
                    if (item.dependentValue && item.dependentValue[valueNext]) {
                        itemToChange.push({ path: item.dependentValue[valueNext][0], value: item.dependentValue[valueNext][1] });
                    }
                    if (item.afterChange) {
                        let selectedItemToNext = optionsSuggest.find((f) => f[item.optionValue ? item.optionValue : "code"] == e.target.value);

                        const newData = item.afterChange({
                            selectedItem: selectedItemToNext,
                            key: key,
                            itemToChange: itemToChange,
                            isAdd: isAdd,
                        });
                        itemToChange = newData;
                    }

                    if (id === "vendorId") {
                        if (item.fetchVendorItemData) item.fetchVendorItemData(e);
                    }

                    // console.log(itemToChange);

                    setDataMulti(itemToChange);
                };

                const handleInputChangeSelectState = (e, id) => {
                    let itemToChange = [];
                    itemToChange.push({ path: prePath.concat(id), value: e.target.value });
                    setDataMulti(prePath.concat(key), value);
                };

                const dropdownClickHandler = async () => {
                    let resp = await mainStore.getByUrl(item.apiUrl, item.dataKey, "", false, false);
                    if (resp && resp.success) {
                        mainStore.setMainStore(item.dataKey, resp.data);
                    }
                };

                const dropdownClickHandlerState = (dataKey, api) => {
                    mainStore.getByUrl(dataKey, api);
                };

                const handleDateChange = (e, id, format = "YYYY-MM-DD") => {
                    let errText = document.querySelector(`small[id="${id}"]`);
                    // console.log('errText',errText);
                    if (errText) {
                        errText.innerHTML = "";
                    }
                    e.originalEvent.target.classList.remove("p-invalid");

                    let value = e.value;
                    if (e.value) {
                        value = moment(e.value).format();
                    }
                    let itemToChange = [];
                    itemToChange.push({ path: prePath.concat(id), value: value });

                    if (item.duplicateToDate) {
                        itemToChange.push({ path: prePath.concat(item.duplicateToDate), value: value });
                    }

                    setDataMulti(itemToChange);
                };

                const handleValueChange = (e, id, value = null) => {
                    if (e) {
                        let errText = document.querySelector(`small[id="${id}"]`);
                        if (errText) {
                            errText.innerHTML = "";
                        }
                        if (e.originalEvent) {
                            e.originalEvent.target.classList.remove("p-invalid");
                            setData(prePath.concat(key), e.value);
                        } else {
                            setData(prePath.concat(key), e.value);
                        }
                    } else if (value) {
                        setData(prePath.concat(key), value);
                    }
                };
                const handleDataChange = (value, id) => {
                    if (typeof value !== "undefined") {
                        const pathMain = prePath.concat(item.keyData ? item.keyData : key);
                        setData(pathMain, value);

                        if (item.translitTo) {
                            const pathTranslit = prePath.concat(item.translitTo);
                            const translitValue = translit(typeof value === "string" ? value.replace(/<\/?[^>]+(>|$)/g, "") : value);

                            setData(pathTranslit, translitValue);
                        }
                    } else {
                        let errText = document.querySelector(`small[id="${id}"]`);
                        if (errText) {
                            errText.innerHTML = "";
                        }
                    }
                };

                const handleCheckboxChange = (e) => {
                    let a = e.checked ? true : false;
                    setData(prePath.concat(key), a);
                };

                const handleSwitch = (e) => {
                    if (item.handleChangeSwitch) item.handleChangeSwitch(key, e.value, changeableData);
                    if (item.keyArray) {
                        if (e.value) {
                            if (changeableData.offerOptions) {
                                setData(prePath.concat(key), [...changeableData.offerOptions, item.keyArray]);
                            } else {
                                setData(prePath.concat(key), [item.keyArray]);
                            }
                        } else {
                            setData(prePath.concat(key), changeableData.offerOptions ? changeableData.offerOptions.filter((i) => i !== item.keyArray) : [item.keyArray].filter((i) => i !== item.keyArray));
                        }
                    } else {
                        setData(prePath.concat(key), e.value);
                    }
                };

                const handleRadioChange = (e) => {
                    if (item.handleChangeRadio) item.handleChangeRadio(key, e);
                    setData(prePath.concat(key), e);
                };

                const handleFileUpload = (data) => {
                    const file = data && data.files && data.files[0] ? data.files[0] : false;
                    if (file) {
                        setData(prePath.concat(key), file);
                        // data.options.clear();
                    }
                };

                const handleDatePeriod = (e, key) => {
                    setData(prePath.concat(key), moment(e).format("DD.MM.YYYY"));
                };

                const handleFileUploadClear = () => {
                    setData(prePath.concat(key), false);
                };

                const handleWeekDays = (value) => {
                    if (typeof value !== "undefined") {
                        if (value[0] > value[1] || value[1] >= 8) return;
                        setData(prePath.concat(key), value);
                    }
                };

                const handleLinkTab = () => {
                    window.open(`/companies/${value}`);
                };

                const handleReorder = (val) => {
                    setData(prePath.concat(key), val);
                };

                let filter = "";
                if (item.keyFilter) {
                    filter = item.keyFilter;
                }

                let typeOut = hide ? "hide" : item.type;

                const isDisabled = item.disabled ? item.disabled : disabled ? disabled : false;

                if (optionsSuggest && item.filterFunction && optionsSuggest.length > 0) {
                    optionsSuggest = item.filterFunction({
                        options: optionsSuggest,
                        currentValue: changeableData,
                    });
                }

                if (item.triggerShow) {
                    const triggerValue = getValByPath(item.triggerShow, changeableData);

                    if (Array.isArray(triggerValue) && typeof item.triggerShowValue == "string") {
                        if (!triggerValue.includes(item.triggerShowValue)) {
                            typeOut = "hide";
                        }
                    } else {
                        // Преобразуем к массиву, если это не массив
                        const triggerShowArray = Array.isArray(item.triggerShowValue) ? item.triggerShowValue : [item.triggerShowValue];

                        if (
                            // можно проверять несколько ключей в массиве
                            (item.triggerKeys && changeableData[item.triggerShow] && changeableData[item.triggerShow].some((s) => Object.entries(item.triggerKeys).every(([key, val]) => s[key] === val)) == item.triggerShowValue) ||
                            !triggerValue ||
                            (item.triggerShowValue && !triggerShowArray.includes(triggerValue))
                        ) {
                            typeOut = "hide";
                        }
                    }
                }

                switch (typeOut) {
                    case "delimetr":
                        return (
                            <div key={key} className={`detail__item full-width delimetr`}>
                                <label>{item.label}</label>
                            </div>
                        );
                    case "string":
                        return (
                            <InputUI
                                addClass={item.addClass}
                                dataId={dataId}
                                label={item.label}
                                required={item.required}
                                placeholder={item.placeholder}
                                value={value}
                                onChange={(e) => handleInputChange(e, dataId.join("."))}
                                disabled={isDisabled}
                                keyfilter={filter}
                                maxLength={item.maxLength}
                                error={item.error}
                            />
                        );
                    case "radiobutton":
                        return (
                            <RadioButtonUI
                                addClass={item.addClass}
                                label={item.label}
                                radioData={item.radioButtonData ? item.radioButtonData : []}
                                value={value !== "" && value != null ? value : item.defaultValue}
                                setData={setData}
                                setDataMulti={setDataMulti}
                                changeableData={changeableData}
                                onChange={(e) => handleRadioChange(e.value)}
                                error={item.error}
                                disabled={isDisabled}
                            />
                        );
                    case "number":
                        return (
                            <InputNumberUI
                                label={item.label}
                                placeholder={item.placeholder ? item.placeholder : "Укажите число"}
                                id={key}
                                disabled={isDisabled}
                                value={value}
                                onChange={(e) => handleValueChange(item.max && e.value > item.max ? { ...e, value: item.max } : e, dataId.join("."))}
                                dataId={dataId}
                                mode={item.mode}
                                required={item.required}
                                maxLength={item.maxLength ? item.maxLength : null}
                                max={item.max ? item.max : null}
                                min={item.minLength ? item.minLength : 0}
                                useGrouping={item.useGrouping}
                                suffix={item.suffix ? item.suffix : null}
                                addClass={item.addClass}
                                invalid={item.error}
                                minFractionDigits={item.minFractionDigits}
                                maxFractionDigits={item.maxFractionDigits}
                            />
                        );
                    case "copyTag":
                        return <CopyTagUI label={item.label} copyLabel={item.copyLabel} className={item.className} />;
                    case "objectInputs":
                        const objectInputs = item.inputs;
                        const objectPathIn = item.label;
                        const inObjKey = item.inObjKey;
                        const inputs =
                            inObjKey && value
                                ? Object.keys(value).reduce((acc, row) => {
                                      acc[row] = { label: row, type: "string", required: true, disabled: true };
                                      return acc;
                                  }, {})
                                : {};

                        const outObjInputs = inObjKey && value ? inputs : objectInputs;
                        return Object.keys(outObjInputs).map((keyInputsArray, indexInputsArray) => {
                            const val = value && keyInputsArray in value ? value[keyInputsArray] : "";

                            const errorKey = errorArr?.find((s) => s === keyInputsArray);

                            if (keyInputsArray === errorKey) {
                                outObjInputs[keyInputsArray].error = true;
                            } else {
                                outObjInputs[keyInputsArray].error = false;
                            }

                            return (
                                <CreateNode
                                    key={objectPathIn + "_" + keyInputsArray}
                                    keyTo={`${key}.${keyInputsArray}`}
                                    item={outObjInputs[keyInputsArray]}
                                    value={val}
                                    setData={setData}
                                    setDataMulti={setDataMulti}
                                    isAdd={isAdd}
                                    dataId={[key, keyInputsArray]}
                                    disabled={disabled}
                                    siteId={siteId}
                                    changeableData={changeableData}
                                />
                            );
                        });

                    case "objectInput":
                        return item.inputs.map((group, groupIdx) => {
                            return Object.keys(group).map((fieldName, fieldIdx) => {
                                const field = group[fieldName];
                                const uniqueKey = `${keyTo}_${groupIdx}_${fieldName}`;

                                const val = value?.[fieldName] ?? "";

                                return (
                                    <div key={uniqueKey} className={`detail__item ${field.addClass ? field.addClass : ""}`}>
                                        <label className={dataId.join("-")} htmlFor={uniqueKey} data-pr-tooltip={field.label}>
                                            {field.label}
                                            {item.required ? "*" : ""}
                                        </label>
                                        <InputTextareaUI
                                            placeholder={field.placeholder ? field.placeholder : "Опишите подробнее"}
                                            id={uniqueKey}
                                            value={val}
                                            onChange={(e) => handleInputChange(e, [fieldName].join("."))}
                                            className=""
                                            rows={1}
                                            cols={30}
                                            data-id={dataId.join(".")}
                                            disabled={isDisabled}
                                        />
                                    </div>
                                );
                            });
                        });

                    case "textArea":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <InputTextareaUI
                                    placeholder={item.placeholder ? item.placeholder : "Опишите подробнее"}
                                    id={key}
                                    value={value || ""}
                                    onChange={(e) => handleInputChange(e, dataId.join("."))}
                                    className={""}
                                    rows={1}
                                    cols={30}
                                    data-id={dataId.join(".")}
                                    disabled={isDisabled}
                                    maxLength={item.maxLength}
                                    invalid={item.error}
                                />
                                {item.count ? <span style={{ textAlign: "right" }}>{value.length} / 300</span> : null}
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                            </div>
                        );

                    case "email":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <InputUI
                                    placeholder={item.placeholder}
                                    id={key}
                                    disabled={isDisabled}
                                    value={value || ""}
                                    onChange={(e) => handleInputChange(e, dataId.join("."))}
                                    keyfilter={"email"}
                                    className={validEmail.current ? "p-invalid" : ""}
                                    data-id={dataId.join(".")}
                                    invalid={item.error}
                                />
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                            </div>
                        );
                    case "phone":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <InputMask
                                    id={key}
                                    disabled={isDisabled}
                                    value={value || ""}
                                    onChange={(e) => handleInputChange(e, dataId.join("."))}
                                    mask={"+9 (999) 999 9999"}
                                    className={value && value.length !== 11 ? "p-invalid" : ""}
                                    unmask
                                    data-id={dataId.join(".")}
                                />
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                            </div>
                        );
                    case "select":
                    case "selectSuggest":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                    <label className={dataId.join("-")} htmlFor={key}>
                                        {item.label}
                                        {item.required ? "*" : ""}
                                    </label>
                                    {item?.copied ? <i onClick={handleCopy} className="pi pi-copy"></i> : null}
                                </div>
                                <Dropdown
                                    id={key}
                                    filter={item.filter !== "no" ? true : false}
                                    filterBy={item.filterBy}
                                    disabled={isDisabled}
                                    showClear={item.showClear ?? true}
                                    value={value}
                                    onChange={(e) => handleInputChange(e, dataId.join("."))}
                                    onShow={item?.fetchOnClick ? (e) => dropdownClickHandler(e) : () => {}}
                                    options={optionsSuggest}
                                    optionValue={item.optionValue ? item.optionValue : "code"}
                                    optionLabel={item.optionLabel ? item.optionLabel : "code"}
                                    placeholder={item.placeholder || "Выберите из списка"}
                                    emptyFilterMessage={"Нет элементов для выбора"}
                                    emptymessage={"Нет элементов для выбора"}
                                    emptyMessage={"Нет элементов для выбора"}
                                    data-id={dataId.join(".")}
                                    className="detail__item_dropdown"
                                    appendTo={item.appendTo ? item.appendTo : document.body}
                                    virtualScrollerOptions={{ itemSize: 44 }}
                                    invalid={item.error}
                                />
                            </div>
                        );
                    case "multiselect":
                    case "multiSelect":
                    case "multiSelectSuggest":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <MultiSelect
                                    filter={true}
                                    filterBy={item.filterBy}
                                    value={value ? [...value] : []}
                                    options={optionsSuggest}
                                    optionValue={item.optionValue ? item.optionValue : ""}
                                    optionLabel={item.optionLabel ? item.optionLabel : "code"}
                                    placeholder={item.placeholder || "Выберите из списка"}
                                    showClear={true}
                                    emptyFilterMessage={"Нет элементов для выбора"}
                                    emptyMessage={"Нет элементов для выбора"}
                                    disabled={isDisabled}
                                    data-id={dataId.join(".")}
                                    showSelectAll={item.showSelectAll ? item.showSelectAll : false}
                                    onChange={(e) => {
                                        handleInputChange(e, dataId.join("."));
                                    }}
                                    appendTo={item.appendTo ? item.appendTo : document.body}
                                    display="chip"
                                    virtualScrollerOptions={{ itemSize: 44 }}
                                    invalid={item.error}
                                />
                            </div>
                        );
                    case "multiSelectTemplate": // единичный случай, для подсветки определенных опций мультиселекта
                        const enhancedOptions = optionsSuggest.map((opt) => {
                            if (opt.siteInfo && opt.siteInfo.categoriesIds && changeableData.vendor && changeableData.vendor.categoriesIds) {
                                const a = opt.siteInfo.categoriesIds;
                                const b = changeableData.vendor.categoriesIds;
                                const areSame = a.length && b.length && a.some((id) => b.includes(id)) && b.some((id) => a.includes(id));

                                return areSame ? { ...opt, areSame: true } : opt;
                            }
                            return opt;
                        });

                        const label = item.optionLabel ? item.optionLabel : "code";

                        const renderSelectItem = (itemId) => {
                            if (!itemId) return null;
                            const val = enhancedOptions.find((f) => f._id == itemId);
                            return (
                                <div className={`p-multiselect-token ${val?.areSame ? "p-multiselect-token_error" : ""}`}>
                                    <span className="p-multiselect-token-label">{val ? `${val[label]}` : ""}</span>
                                    <i
                                        style={{ cursor: "pointer", marginLeft: 5 }}
                                        className="pi pi-times-circle"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const newVal = value.filter((o) => o !== itemId);
                                            setData(prePath.concat(key), newVal);
                                        }}
                                    />
                                </div>
                            );
                        };

                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <MultiSelect
                                    filter={true}
                                    filterBy={item.filterBy}
                                    value={value ? [...value] : []}
                                    options={enhancedOptions}
                                    optionValue={item.optionValue ? item.optionValue : ""}
                                    optionLabel={label}
                                    placeholder={item.placeholder || "Выберите из списка"}
                                    showClear={true}
                                    emptyFilterMessage={"Нет элементов для выбора"}
                                    emptyMessage={"Нет элементов для выбора"}
                                    disabled={isDisabled}
                                    data-id={dataId.join(".")}
                                    showSelectAll={item.showSelectAll ? item.showSelectAll : false}
                                    onChange={(e) => {
                                        handleInputChange(e, dataId.join("."));
                                    }}
                                    appendTo={item.appendTo ? item.appendTo : document.body}
                                    display="chip"
                                    virtualScrollerOptions={{ itemSize: 44 }}
                                    itemTemplate={(option) => (item.itemTemplate ? item.itemTemplate(option) : option[label])}
                                    selectedItemTemplate={renderSelectItem}
                                    invalid={item.error}
                                />
                                {enhancedOptions.some((opt) => value.includes(opt._id) && opt.areSame) ? (
                                    <Message
                                        severity="warn"
                                        text="Вы выбрали витрину из схожей категории — проверьте, можно ли использовать его для публикации оффера."
                                        style={{
                                            border: "solid #CC8925",
                                            borderWidth: "0 0 0 6px",
                                            color: "#CC8925",
                                            padding: "17.5px 24.5px 17.5px",
                                            justifyContent: "flex-start",
                                        }}
                                    />
                                ) : null}
                            </div>
                        );
                    case "date":
                        // console.log(value);

                        const testDateValid = value ? moment(value, "YYYY-MM-DD", true) : false;
                        const dateValue = value ? (testDateValid.isValid() ? moment(value, "YYYY-MM-DD").toDate() : new Date(value)) : false;

                        return (
                            <div key={key} className={`detail__item detail__item-date ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <div>
                                    <Calendar
                                        showTime={item.showTime || false}
                                        placeholder={"Выберите дату"}
                                        id={key}
                                        disabled={isDisabled}
                                        // (isAdd && item.curDate) ? moment().toDate() :
                                        value={value ? dateValue : null}
                                        onChange={(e) => handleDateChange(e, dataId.join("."), "YYYY-MM-DD")}
                                        // minDate={
                                        //     minDate ? minDate : typeof item.minDate !== 'undefined'?item.minDate:new Date()
                                        // }
                                        // maxDate={
                                        //     maxDate ? maxDate : typeof item.maxDate !== 'undefined'?item.maxDate:null
                                        // }
                                        dateFormat="dd.mm.yy"
                                        data-id={dataId.join(".")}
                                        locale="rus"
                                        invalid={item.error}
                                    />
                                    {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                                    <i className="pi pi-calendar"></i>
                                </div>
                            </div>
                        );

                    case "datePeriod":
                        const [date, setDate] = useState({ dateStart: null, dateEnd: null });

                        return (
                            <div key={key} className={`detail__item detail__item-date ${item.addClass ? item.addClass : ""}`}>
                                <label className="label">{item.label}</label>
                                <div className="ui-container__block">
                                    <div className="ui-container__block item">
                                        <Calendar
                                            id="dateStart"
                                            value={date.dateStart}
                                            disabled={isDisabled}
                                            onChange={(e) => {
                                                handleDatePeriod(e.value, "dateStart");
                                                setDate({ ...date, dateStart: e.value });
                                            }}
                                            dateFormat="С dd.mm.yy"
                                            placeholder="Укажите дату"
                                            invalid={item.error}
                                        />
                                        <i className="pi pi-calendar"></i>
                                    </div>

                                    <div className="ui-container__block item">
                                        <Calendar
                                            id="dateEnd"
                                            value={date.dateEnd}
                                            disabled={isDisabled}
                                            onChange={(e) => {
                                                handleDatePeriod(e.value, "dateEnd");
                                                setDate({ ...date, dateEnd: e.value });
                                            }}
                                            dateFormat="По dd.mm.yy"
                                            placeholder="Укажите дату"
                                            invalid={item.error}
                                        />
                                        <i className="pi pi-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        );
                    case "dateTime":
                        const currentOffset = moment().utcOffset();

                        const onChangeCalendar = (eIn, ed, eda) => {
                            let eData = { ...eIn };
                            eData.value = eData.value ? moment(eData.value).utc(true).toDate() : moment().utc().toDate();
                            handleDateChange(eData, dataId.join("."), "YYYY-MM-DDTHH:mmZ");
                        };

                        const valueOut = value ? moment(value).clone().subtract(currentOffset, "minutes").toDate() : null;

                        const valToLocalTime = value ? moment(value).format("LLL") : moment().format("LLL");

                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <Calendar
                                    id={key}
                                    disabled={isDisabled}
                                    mask={item.timeOnly ? "99:99" : "99.99.9999 99:99"}
                                    value={valueOut || null}
                                    onChange={onChangeCalendar}
                                    dateFormat="dd.mm.yy"
                                    showTime
                                    hourFormat="24"
                                    data-id={dataId.join(".")}
                                    locale="rus"
                                    timeOnly={item.timeOnly || false}
                                    placeholder={item.placeholder || "Выберите дату и время"}
                                    invalid={item.error}
                                />
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                                {!item.isDisableText && !item.timeOnly && valueOut ? (
                                    <span id={dataId.join(".")}>
                                        Соответствует <b>{valToLocalTime}</b> местного времени
                                    </span>
                                ) : null}
                            </div>
                        );
                    case "time":
                        const testTimeValid = value ? moment(value, "HH:mm", true) : false;
                        const dateTimeValue = value ? (testTimeValid.isValid() ? moment(value, "HH:mm").toDate() : new Date(value)) : false;
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <Calendar
                                    id={key}
                                    disabled={isDisabled}
                                    mask={"99:99"}
                                    value={value ? new Date(dateTimeValue) : null}
                                    onChange={(e) => handleDateChange(e, dataId.join("."), "HH:mm")}
                                    minDate={minDate ? minDate : typeof item.minDate !== "undefined" ? item.minDate : new Date()}
                                    maxDate={maxDate ? maxDate : typeof item.maxDate !== "undefined" ? item.maxDate : null}
                                    timeOnly
                                    data-id={dataId.join(".")}
                                    invalid={item.error}
                                />
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                            </div>
                        );
                    case "checkbox":
                        return (
                            <div key={key} className={`detail__item checkbox ${item.addClass ? item.addClass : ""}`}>
                                <div className={`checkbox__container ${item.addClass ? item.addClass : ""}`}>
                                    <label htmlFor={key}>{item.label}</label>
                                    <CheckboxUI id={key} disabled={isDisabled} onChange={handleCheckboxChange} checked={value == "true" || value == true ? true : false} data-id={dataId.join(".")} />
                                </div>
                            </div>
                        );

                    case "dropdownSearch":
                        let selectedItemDrop = optionsSuggest.find((f) => f.code == value);
                        tooltip = selectedItemDrop ? selectedItemDrop.name : "";

                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                {/* <Tooltip target={`.${dataId.join('-')}`} position='left' /> */}
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <Dropdown
                                    id={key}
                                    disabled={isDisabled}
                                    value={value}
                                    onChange={(e) => handleInputChange(e, dataId.join("."))}
                                    options={optionsSuggest}
                                    optionValue="code"
                                    optionLabel="name"
                                    placeholder={item.placeholder}
                                    data-id={dataId.join(".")}
                                    className="detail__item_dropdown"
                                    appendTo="self"
                                    tooltip={tooltip}
                                    filter
                                    virtualScrollerOptions={{ itemSize: 44 }}
                                    invalid={item.error}
                                />
                                {/* <small id={dataId.join('.')} className={`p-error block error-text ${dataId.join('-')}`}></small> */}
                            </div>
                        );
                    case "codeEditor":
                        // console.log(fullData);
                        return <CodeEditor dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} fullData={fullData} handleDataChange={handleDataChange} invalid={item.error} />;
                    case "timeArray":
                        // console.log(fullData);
                        return <TimeArray dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} fullData={fullData} handleDataChange={handleDataChange} />;
                    // coverDetail: {label: 'Баннер Деталка(coverDetail)', type:'image', required: true, pathStorage: 'coverDetail', addClass:'imageupload'},
                    case "image":
                        return (
                            <Image
                                dataId={dataId}
                                item={item}
                                keyData={key}
                                data={fullData}
                                isDisabled={isDisabled}
                                value={value}
                                siteId={siteId}
                                handleDataChange={handleDataChange}
                                className={`${item.addClass ? item.addClass : ""}`}
                                urlUpload={urlUpload}
                                changeableData={changeableData}
                                error={item.error}
                            />
                        );

                    case "selectSuggestState":
                        const [stateSelect, setStateSelect] = useState(false);
                        const [valueState, setValueState] = useState(false);

                        let stateData = item && item.state ? item.state : {};
                        const dataOptions = dataStore.getDataStore(stateData[stateSelect] ? stateData[stateSelect].dataKey : "");

                        const keyState = stateData[stateSelect] ? stateData[stateSelect].id : "";

                        let optionsSuggestState = stateData[stateSelect] && stateData[stateSelect].options ? stateData[stateSelect].options : dataOptions && dataOptions.success ? dataOptions.data : [];

                        useEffect(() => {
                            if (fullData && optionsSuggestState) {
                                setStateSelect(fullData && fullData.parentType ? fullData.parentType : false);
                                let it = optionsSuggestState.filter((el) => el._id === fullData.parentId);

                                if (it.length) {
                                    setValueState(it[0]._id);
                                }

                                // setValueState(
                                //     optionsSuggestState.filter((it) => {
                                //         it.id === fullData.parentId;
                                //     }),
                                // );
                            }
                        }, [fullData, optionsSuggestState]);

                        const getList = async () => {
                            dataStore.getDataByUrl(stateData[stateSelect].dataKey, stateData[stateSelect].apiUrl);
                        };

                        useEffect(() => {
                            if (stateSelect) {
                                getList();
                            }
                        }, [stateSelect]);

                        return (
                            <>
                                <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                        <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                            {item.label}
                                            {item.required ? "*" : ""}
                                        </label>
                                        {item?.copied ? <i onClick={handleCopy} className="pi pi-copy"></i> : null}
                                    </div>
                                    <Dropdown
                                        id={key}
                                        filter={item.filter !== "no" ? true : false}
                                        filterBy={item.filterBy}
                                        disabled={isDisabled}
                                        showClear={true}
                                        value={value}
                                        onChange={(e) => {
                                            handleInputChange(e, dataId.join("."));
                                            setStateSelect(e.value);
                                        }}
                                        onFocus={item?.fetchOnClick ? (e) => dropdownClickHandler(e) : () => {}}
                                        options={optionsSuggest}
                                        optionValue={item.optionValue ? item.optionValue : "code"}
                                        optionLabel={item.optionLabel ? item.optionLabel : "code"}
                                        placeholder={item.placeholder}
                                        emptyFilterMessage={"Нет элементов для выбора"}
                                        emptymessage={"Нет элементов для выбора"}
                                        emptyMessage={"Нет элементов для выбора"}
                                        data-id={dataId.join(".")}
                                        className="detail__item_dropdown"
                                        appendTo={item.appendTo ? item.appendTo : document.body}
                                        tooltip={tooltip}
                                        invalid={item.error}
                                    />
                                </div>

                                {stateData[stateSelect] ? (
                                    <div key={keyState} className={`detail__item ${stateData[stateSelect].addClass ? stateData[stateSelect].addClass : ""}`}>
                                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                            <label className={dataId.join("-")} htmlFor={keyState} data-pr-tooltip={stateData[stateSelect].label}>
                                                {stateData[stateSelect].label}
                                                {stateData[stateSelect].required ? "*" : ""}
                                            </label>
                                            {stateData[stateSelect]?.copied ? <i onClick={handleCopy} className="pi pi-copy"></i> : null}
                                        </div>
                                        <Dropdown
                                            id={keyState}
                                            filter={stateData[stateSelect].filter !== "no" ? true : false}
                                            filterBy={stateData[stateSelect].filterBy}
                                            disabled={isDisabled}
                                            showClear={true}
                                            value={valueState}
                                            onChange={(e) => {
                                                setValueState(e.value);
                                                handleInputChangeSelectState(e, stateData[stateSelect].id);
                                            }}
                                            onFocus={stateData[stateSelect].fetchOnClick ? (e) => dropdownClickHandlerState(stateData[stateSelect].dataKey, stateData[stateSelect].apiUrl) : () => {}}
                                            options={optionsSuggestState}
                                            optionValue={stateData[stateSelect] && stateData[stateSelect].optionValue ? stateData[stateSelect].optionValue : "code"}
                                            optionLabel={stateData[stateSelect] && stateData[stateSelect].optionLabel ? stateData[stateSelect].optionLabel : "code"}
                                            placeholder={stateData[stateSelect].placeholder}
                                            emptyFilterMessage={"Нет элементов для выбора"}
                                            emptymessage={"Нет элементов для выбора"}
                                            emptyMessage={"Нет элементов для выбора"}
                                            data-id={stateData[stateSelect].id}
                                            className="detail__item_dropdown"
                                            appendTo={stateData[stateSelect].appendTo ? stateData[stateSelect].appendTo : document.body}
                                            tooltip={tooltip}
                                            invalid={item.error}
                                        />
                                    </div>
                                ) : null}
                            </>
                        );
                    case "fileUpload":
                        const cancelOptions = {
                            icon: "pi pi-fw pi-times",
                            iconOnly: true,
                            className: "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
                        };

                        const headerTemplate = (options) => {
                            const { className, chooseButton, uploadButton, cancelButton } = options;

                            return (
                                <div className={className} style={{ backgroundColor: "transparent", display: "flex", alignItems: "center" }}>
                                    {chooseButton}
                                    <ButtonUI icon="pi pi-fw pi-times" className="custom-cancel-btn p-button-danger p-button-rounded p-button-outlined" onClick={cancelButton.props.onClick} />
                                </div>
                            );
                        };

                        const itemTemplate = (file, props) => {
                            return (
                                <div className="fileUpload__itemTemplate">
                                    <div>{file.name}</div>
                                    <ButtonUI type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={props.onRemove} />
                                </div>
                            );
                        };

                        const emptyTemplate = () => {
                            return <div className="fileUpload__emptyTemplate">Перетащите файл</div>;
                        };

                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <FileUpload
                                    name="demo[]"
                                    url={"/api/upload"}
                                    // accept="image/*"
                                    maxFileSize={20000000}
                                    disabled={value && !multiple ? true : false}
                                    // mode="basic"
                                    customUpload
                                    onSelect={handleFileUpload}
                                    onClear={handleFileUploadClear}
                                    ref={fileInputRef}
                                    chooseLabel="Загрузить"
                                    multiple={multiple}
                                    headerTemplate={headerTemplate}
                                    itemTemplate={itemTemplate}
                                    emptyTemplate={emptyTemplate}
                                    cancelOptions={cancelOptions}
                                />
                            </div>
                        );
                    case "sound":
                        return <Sound dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} siteId={siteId} handleDataChange={handleDataChange} />;
                    case "document":
                        return <Document dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} siteId={siteId} handleDataChange={handleDataChange} />;
                    case "pdf":
                        return <Pdf dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} siteId={siteId} handleDataChange={handleDataChange} />;
                    case "stringInputs":
                        const valueStringInputs = value ? value : [];

                        const changeHandler = (e, index) => {
                            let currentValue = valueStringInputs;
                            if (e.target.value.length <= 512) {
                                currentValue[index] = e.target.value;
                                handleDataChange(currentValue, keyTo);
                            }
                        };

                        const clickHandler = () => {
                            let currentValue = valueStringInputs;
                            currentValue.push("");
                            handleDataChange(currentValue, keyTo);
                        };

                        const confirm = (event, index) => {
                            confirmPopup({
                                target: event.currentTarget,
                                rejectLabel: "Нет",
                                acceptLabel: "Да",
                                message: "Вы уверены что хотите удалить картинку",
                                icon: "pi pi-exclamation-triangle",
                                accept: () => {
                                    let currentValue = [...valueStringInputs];
                                    currentValue.splice(index, 1);
                                    handleDataChange(currentValue, keyTo);
                                },
                                reject: () => {},
                            });
                        };

                        const btnDisabled = valueStringInputs.length >= 10 || valueStringInputs.some((s) => !s);

                        return (
                            <div key={key} className="detail__item full" style={{ width: "100%" }}>
                                <div className="stringInputs">
                                    {valueStringInputs.map((stringInputsItem, stringInputIndex) => {
                                        return (
                                            <div className="detail__container_items" key={stringInputIndex}>
                                                <div key={key} className={`detail__item`}>
                                                    <label>
                                                        Картинка {stringInputIndex + 1}
                                                        {stringInputIndex == 0 ? " (основная)" : null}
                                                        <i onClick={(e) => confirm(e, stringInputIndex)} className="pi pi-trash"></i>
                                                    </label>
                                                    <InputUI placeholder={item.placeholder} id={key} value={stringInputsItem || ""} onChange={(e) => changeHandler(e, stringInputIndex)} invalid={item.error} />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <ButtonUI label={"Добавить"} className="p-button-text" onClick={clickHandler} disabled={btnDisabled} />
                            </div>
                        );
                    case "arrayInputs":
                        const valueArrayInputs = value ? value : [];

                        const addClickHandler = () => {
                            let currentValue = valueArrayInputs;
                            currentValue.push({});
                            handleDataChange(currentValue, keyTo);
                        };

                        // const btnDisabled = valueArrayInputs.some(s => reqFields.some(s2 => !s[s2]))

                        return (
                            <div key={key} className="detail__item full" style={{ width: "100%" }}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                {valueArrayInputs.map((itemValueArray, keyValueArray) => {
                                    const itemInputs = item.inputs;

                                    const confirm = (event) => {
                                        confirmPopup({
                                            target: event.currentTarget,
                                            rejectLabel: "Нет",
                                            acceptLabel: "Да",
                                            message: "Вы уверены что хотите удалить элемент",
                                            icon: "pi pi-exclamation-triangle",
                                            accept: (index) => {
                                                let currentValue = [...valueArrayInputs];
                                                currentValue.splice(keyValueArray, 1);
                                                handleDataChange(currentValue, keyTo);
                                            },
                                            reject: () => {},
                                        });
                                    };

                                    return (
                                        <div className="detail__container_items conteiner-arrayit" key={keyValueArray}>
                                            <div className="head-with-button">
                                                <h3 className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                                    {item.label} {keyValueArray + 1}
                                                </h3>
                                                {/* label="Удалить элемент" */}
                                                <ButtonUI icon="pi pi-trash" onClick={confirm} className="p-button-text" />
                                            </div>
                                            {Object.keys(itemInputs).map((keyInputsArray, indexInputsArray) => {
                                                const currentInput = itemInputs[keyInputsArray];

                                                let shouldShow = true;
                                                if (currentInput.triggerShow) {
                                                    const triggerValue = getValByPath(currentInput.triggerShow, itemValueArray);
                                                    const triggerShowValues = Array.isArray(currentInput.triggerShowValue) ? currentInput.triggerShowValue : [currentInput.triggerShowValue];

                                                    if (!triggerShowValues.includes(triggerValue)) {
                                                        shouldShow = false;
                                                    }
                                                }

                                                if (!shouldShow) {
                                                    return null;
                                                }

                                                const val = itemValueArray?.[keyInputsArray] ?? "";

                                                return (
                                                    <CreateNode
                                                        key={indexInputsArray}
                                                        fullData={itemValueArray}
                                                        keyTo={`${key}.${keyValueArray}.${keyInputsArray}`}
                                                        item={currentInput}
                                                        value={val}
                                                        setData={setData}
                                                        setDataMulti={setDataMulti}
                                                        isAdd={isAdd}
                                                        dataId={[key, keyValueArray, keyInputsArray]}
                                                        disabled={disabled}
                                                        siteId={siteId}
                                                        changeableData={itemValueArray}
                                                    />
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                                <ButtonUI
                                    label={item.buttonLabel ? item.buttonLabel : "Добавить"}
                                    className="p-button-text"
                                    onClick={addClickHandler}
                                    // disabled={btnDisabled}
                                />
                            </div>
                        );
                    case "selectButton":
                        return (
                            <div key={key} className={`detail__item selectButton ${item.addClass ? item.addClass : ""}`}>
                                <SelectButtonUI value={value} options={item.options} onChange={(e) => handleInputChange(e, dataId.join("."))} optionLabel={item.optionLabel ? item.optionLabel : "name"} allowEmpty={false} />
                            </div>
                        );

                    case "switch":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <div className="switch">
                                    <InputSwitch onChange={handleSwitch} checked={item.keyArray ? value?.includes(item.keyArray) : value} disabled={isDisabled} />
                                    <label className="switch__label">{item.switchLabel}</label>
                                </div>
                            </div>
                        );

                    case "link":
                        return (
                            <div className="link">
                                <a href={item.href} target="_blank" rel="noreferrer">
                                    {item.label}
                                </a>
                            </div>
                        );

                    case "previewItem":
                        const isHit = changeableData?.offerOptions?.includes("hit");
                        const vendorImgs = { cover: changeableData?.vendor?.logoList, coverMobile: changeableData?.vendor?.squareLogo };
                        const image = changeableData?.[item.pathStorage] || vendorImgs?.[item.pathStorage] || "";

                        return (
                            <div key={key} className={`previev-list-container ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <div className={`list-item ${isHit ? "hit" : ""}`} id={item.screenshot ? "screen" : ""}>
                                    <div className="list-item__logo">
                                        <Image
                                            dataId={dataId}
                                            item={item}
                                            keyData={key}
                                            data={fullData}
                                            isDisabled={isDisabled}
                                            value={image}
                                            siteId={siteId}
                                            handleDataChange={handleDataChange}
                                            className={`${item.addClass ? item.addClass : ""}`}
                                            urlUpload={urlUpload}
                                            noRemove={!!item.noRemove}
                                            noLabel
                                            changeableData={changeableData}
                                        />
                                    </div>

                                    <div className="list-item__title-container">
                                        <span
                                            className="list-item__title"
                                            dangerouslySetInnerHTML={{
                                                __html: changeableData.title || "Введите название оффера",
                                            }}
                                        />
                                    </div>

                                    {isHit ? <span className={`list-item__hit-label`}>хит</span> : null}

                                    <div className={`list-item__btn`}>
                                        <svg id="svg" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M16 28V16M16 9.33333H10.6C6.90668 9.33333 6.68002 4 10.6 4C14.8 4 16 9.33333 16 9.33333ZM16 9.33333H21.4C25.2614 9.33333 25.2614 4 21.4 4C17.2 4 16 9.33333 16 9.33333Z"
                                                stroke={"#B1BAD4"}
                                                strokeWidth="1.33333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M26.6667 16.0002V25.3335C26.6667 26.0407 26.3857 26.719 25.8856 27.2191C25.3855 27.7192 24.7072 28.0002 24 28.0002H8C7.29276 28.0002 6.61448 27.7192 6.11438 27.2191C5.61428 26.719 5.33333 26.0407 5.33333 25.3335V16.0002M28 16.0002V12.0002C28 11.2929 27.719 10.6146 27.219 10.1145C26.7189 9.61445 26.0406 9.3335 25.3333 9.3335H6.66667C5.95942 9.3335 5.28115 9.61445 4.78105 10.1145C4.28095 10.6146 4 11.2929 4 12.0002V16.0002H28Z"
                                                stroke={"#B1BAD4"}
                                                strokeWidth="1.33333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        );

                    case "label":
                        return (
                            <span className={`detail__item ${item.addClass ? item.addClass : ""}`} style={item.style}>
                                {item.label}
                            </span>
                        );

                    case "weekDays":
                        return <WeekDaysSlider value={value} item={item} week={week} weeksArray={weeksArray} handleWeekDays={handleWeekDays} isDisabled={isDisabled} dataId={dataId} />;
                    case "accordion":
                        const renderHeader = () => (
                            <div className="accordion__header">
                                <i className={item.icon} />
                                <strong>{item.header}</strong>
                            </div>
                        );
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <Accordion activeIndex={[0]} className="accordion">
                                    <AccordionTab header={renderHeader()}>{item.content}</AccordionTab>
                                </Accordion>
                            </div>
                        );
                    case "orderList":
                        return <ReorderList onChange={handleReorder} items={value || []} changeableData={changeableData} {...item} disabled={isDisabled} />;

                    case "htmlText":
                        return <HtmlText dataId={dataId} item={item} keyData={key} isDisabled={isDisabled} value={value} fullData={fullData} handleDataChange={handleDataChange} error={item.error} />;

                    case "preview":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <Preview changeableData={changeableData} item={item} />
                            </div>
                        );

                    case "previewDisclaimer":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <PreviewDisclaimer changeableData={changeableData} item={item} />
                            </div>
                        );

                    case "rates":
                        return <Rates dataId={dataId} value={value} item={item} setDataMulti={setDataMulti} apiUrl={item.apiUrl} error={item.error} disabled={isDisabled} />;

                    case "ratesTraffic":
                        return <RatesTraffic dataId={dataId} value={value} item={item} setDataMulti={setDataMulti} apiUrl={item.apiUrl} changeableData={changeableData} />;

                    case "defaultCard":
                        return (
                            <div key={key} className={`detail__item ${item.addClass ? item.addClass : ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <DefaultCard item={item} changeableData={changeableData} />
                            </div>
                        );
                    case "questions":
                        return <Questions changeableData={changeableData} item={item} prePath={prePath} disabled={isDisabled} />;

                    case "ord":
                        return <Ord changeableData={changeableData} value={value} dataKey={urlUpload} error={item.error} />;

                    case "ordCompanies":
                        return <CompaniesOrd changeableData={changeableData} value={value} dataKey={urlUpload} inputFieldsDisable={inputFieldsDisable} isScroll={isScroll} getDetailData={getDetailData} />;

                    case "companiesGeo":
                        return <CompaniesGeo changeableData={changeableData} disabled={isDisabled} />;
                    case "btn":
                        return <ButtonUI {...item} />;

                    case "bucketDetail":
                        return <BucketDetail changeableData={changeableData} />;

                    case "bucketUpload":
                        return <BucketsUpload changeableData={changeableData} />;
                    case "deviceTarget":
                        return <DeviceTarget prePath={[...prePath, keyTo]} disabled={isDisabled} />;
                    case "minMax":
                        const [minMax, setMinMax] = useState({ min: value.min ?? null, max: value.max ?? null });

                        const handleChange = (e, key) => {
                            // console.log(e);

                            setMinMax({ ...minMax, [key]: e.value });
                            handleValueChange(null, dataId.join("."), { ...minMax, [key]: e.value } );
                        };

                        return (
                            <div key={key} className={`detail__item full ${item.addClass || ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <div className="minmax">
                                    <div className="minmax__item">
                                        <span className="minmax__text">мин.</span>
                                        <InputNumberUI
                                            placeholder="0"
                                            value={minMax.min}
                                            onValueChange={(e) => handleChange(e, "min")}
                                            // min={1}
                                            max={minMax.max ?? 100}
                                            useGrouping={false}
                                            minFractionDigits={0}
                                            maxFractionDigits={3}
                                            invalid={item.error}
                                            locale="de-DE"
                                            disabled={isDisabled}
                                        />
                                        <span className="minmax__suffix">%</span>
                                    </div>
                                    <div className="minmax__item">
                                        <span className="minmax__text">макс.</span>
                                        <InputNumberUI
                                            placeholder="0"
                                            value={minMax.max}
                                            onValueChange={(e) => handleChange(e, "max")}
                                            min={minMax.min || 0}
                                            max={100}
                                            useGrouping={false}
                                            minFractionDigits={0}
                                            maxFractionDigits={3}
                                            invalid={item.error}
                                            locale="de-DE"
                                            disabled={isDisabled}
                                        />
                                        <span className="minmax__suffix">%</span>
                                    </div>
                                </div>
                            </div>
                        );
                    case "offerSortConfig":
                        return <OfferSortConfig getButtons={getButtons} disabled={isDisabled} />;

                    case "procent":
                        return (
                            <div key={key} className={`detail__item full ${item.addClass || ""}`}>
                                <label className={dataId.join("-")} htmlFor={key} data-pr-tooltip={item.label}>
                                    {item.label}
                                    {item.required ? "*" : ""}
                                </label>
                                <div className="minmax">
                                    <div className="minmax__item">
                                        <InputNumberUI
                                            placeholder="0"
                                            locale="de-DE"
                                            value={value}
                                            onValueChange={(e) => handleValueChange(e, dataId.join("."))}
                                            min={0}
                                            max={100}
                                            useGrouping={false}
                                            minFractionDigits={0}
                                            maxFractionDigits={3}
                                            invalid={item.error}
                                            disabled={isDisabled}
                                        />
                                        <span className="minmax__suffix">%</span>
                                    </div>
                                </div>
                            </div>
                        );

                    case "linkTab":
                        return value ? (
                            <div onClick={handleLinkTab} className="link__tab">
                                <i className="pi pi-arrow-up-left"></i>
                                <a>{item.label}</a>
                            </div>
                        ) : null;
                    default:
                        return null;
                }
            },
        ),
    ),
);
export default CreateNode;

const weeksArray = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const week = ["понедельник", "вторник", "среда", "четверг", "пятница", "суббота", "воскресенье"];
